import Modal from "bootstrap/js/src/modal";

const caseStudyPopupHTML = document.querySelector('#caseStudyModal');

document.addEventListener("DOMContentLoaded", function () {
    if (caseStudyPopupHTML && localStorage.getItem("caseStudyPopup") !== 'shown') {
        const caseStudyPopup = new Modal(caseStudyPopupHTML);
        
        window.setTimeout(() => {
            caseStudyPopup.show();
        }, 5000);

        caseStudyPopupHTML.addEventListener('hidden.bs.modal', event => {
            localStorage.setItem('caseStudyPopup', 'shown');
        })
    }
});